import React, { useState, useEffect } from "react";
import "./editableMultiSelect.css";
import EditIcon from "@mui/icons-material/Edit";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import PropTypes from "prop-types";
import { MultiSelect } from "react-multi-select-component";
import res from "../../../../resources";

const EditableMultiSelect = ({
  options = [],
  type = "text",
  title,
  editableText,
  placeholder,
  value = [],
  onChangeValue,
  onEditClick,
}) => {
  const [editable, setEditable] = useState(false);
  const [optionss, setOptions] = useState(options);

  const handleMemberships = (selected) => {
    let optionArr = [];
    selected.forEach((item) => {
      optionArr.push(item.value);
    });
    onChangeValue(optionArr);
  };

  const handleNewField = (value) => ({
    label: value,
    value: value.toUpperCase(),
  });

  return (
    <div className="inputDefaultWrapperMS">
      <div>
        <h6 className={editable ? `editableMSTitle` : ""}>{title}</h6>
        {/* <p>{email}</p> */}
        {editable ? (
          <MultiSelect
          className="inputDefaultMSComp"
            isCreatable={true}
            placeholder="Serving Areas"
            options={optionss}
            value={value}
            onChange={handleMemberships}
            labelledBy="Select"
            hasSelectAll={false}
            onCreateOption={handleNewField}
            //disableSearch={true}
            ClearSelectedIcon={null}
            ArrowRenderer={() => (
              <img
                src={res.Images.icons.plus.default}
                alt=""
                style={{ width: "20px", height: "20px" }}
              />
            )}
            ItemRenderer={({ checked, option, onClick, disabled }) => (
              <div className={`item-renderer ${disabled && "disabled"}`}>
                <input
                  type="checkbox"
                  onChange={onClick}
                  checked={checked}
                  tabIndex={-1}
                  disabled={disabled}
                  className="checkbox-round"
                />
                <span>{option.label}</span>
              </div>
            )}
            valueRenderer={(selected, _options) => {
              if (selected.length > 0) {
                const strg = selected.length
                  ? selected.map(({ label }) => label + ",")
                  : "";
                if (strg.toString().length > 30) {
                  return strg.toString().substring(0, 30) + "...";
                } else {
                  return strg;
                }
              } else {
                return " ";
              }
            }}
          />
        ) : (
          <input
            type={type}
            className="inputDefaultMS"
            placeholder={placeholder}
            disabled={!editable}
            onChange={onChangeValue}
            value={placeholder}
          />
        )}

        {editableText && (
          <div
            className="editIconInput"
            onClick={() => {
              editable ? setEditable(false) : setEditable(true);
              onEditClick(!editable);
            }}
          >
            {!editable ? (
              <EditIcon className="editIconSize" />
            ) : (
              <DoneOutlineIcon className="editIconSize" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

EditableMultiSelect.propTypes = {
  options: PropTypes.array,
  type: PropTypes.string,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  editableText: PropTypes.bool,
  onChangeValue: PropTypes.func,
  value: PropTypes.array,
  onEditClick: PropTypes.func,
};

EditableMultiSelect.defaultProps = {
  title: "Title",
  placeholder: "PlaceHolder",
  editableText: true,
};
export default EditableMultiSelect;
